<template>
    <div class="index-intro-section">
        <div class="index-intro-section__main">
            <h1 class="index-intro-section__title">
                Страхование для бизнеса выгоднее с подпиской!
            </h1>
            <p class="index-intro-section__description">
                Все преимущества годового полиса, с оплатой раз в месяц теперь доступно для юридических лиц и индивидуальных предпринимателей
            </p>
            <BaseButton class="index-intro-section__action-button" 
                text="Оформить подписку" 
                size="big" 
                icon-name="arrow-bottom"
                icon-size="small"
                @click.native="scrollTo('process')"
                />
        </div>
        <div class="index-intro-section__cards">
            <ul class="index-intro-section__cards-list">
                <li class="index-intro-section__cards-item"
                    v-for="card in commentCards"
                    :key="card.title">
                    <CommentCard :title="card.title" 
                        :subtitle="card.subtitle" 
                        :image-name="card.imageName" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import BaseButton from '@/components/ui/BaseButton';
import CommentCard from '@/components/ui/CommentCard.vue';
import scrollTo from '@/mixins/scrollTo';

export default {
    name: 'IndexIntroductionSection',
    components: {
        BaseButton,
        CommentCard,
    },
    mixins: [scrollTo],
    data() {
        return {
            commentCards: [
                { title: 'Страховые выплаты', subtitle: 'до 3 000 000₽', imageName: 'wallet' },
                { title: 'Стоимость', subtitle: 'от 390₽/мес.', imageName: 'info' },
                { title: 'Оформление', subtitle: 'Онлайн', imageName: 'chat' },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.index-intro-section {
    $comment-cards-height-mobile: 200px;

    position: relative;

    display: flex;

    @media (#{$screen-small}) {
        flex-direction: column;
    }

    &__main {
        $width-desktop: 605px;
        $width-desktop-min: 429px;
        $width-tablet: 370px;

        flex-shrink: 0;

        width: rem($width-desktop);

        @media #{$screen-big} {
            width: rem($width-desktop-min);
        }

        @media (#{$screen-medium}) {
            width: rem($width-tablet);
        }

        @media (#{$screen-small}) {
            width: 100%;
        }
    }

    &__title {
        @include text-xxxl;

        margin-top: rem($gap-normal);

        @media #{$screen-big} {
            font-size: rem($font-size-xl);

            margin-top: rem($gap-small);
        }

        @media (#{$screen-medium}) {
            font-size: rem($font-size-huge);

            margin-top: 0;
        }

        @media (#{$screen-small}) {
            font-size: rem($font-size-great);
        }
    }

    &__description {
        $safe-margin: 15px;

        @include text-large;

        margin-top: rem($gap-medium);
        margin-right: rem($safe-margin);

        @media #{$screen-big} {
            font-size: rem($font-size-normal);
        }
    }

    &__action-button {
        margin-top: rem($gap-huge);
        margin-bottom: rem(18px);

        @media #{$screen-big} {
            margin-bottom: rem($gap-small);
        }

        @media (#{$screen-medium}) {
            margin-top: rem($gap-large);
            margin-bottom: 0;
        }

        @media (#{$screen-small}) {
            margin-top: rem(calc($comment-cards-height-mobile + $gap-medium * 2));
        }

        
    }

    &__cards {
        $left-margin-desktop: 84px;
        $left-margin-tablet: 50px;

        $action-button-height-mobile: 46px;

        flex-grow: 1;

        margin-left: rem($left-margin-desktop);

        @media (#{$screen-medium}) {
            margin-left: rem($gap-large);
            margin-top: rem(10px);
            margin-bottom: 0;
        }

        @media #{$screen-small} {
            position: absolute;
            bottom: calc($action-button-height-mobile + $gap-medium);

            margin-left: 0;
        }
        
        &-list {
            @include flex-col-between;

            height: 100%;

            @media #{$screen-small} {
                height: rem($comment-cards-height-mobile);
            }   
        }

        &-item {
            &:first-child {
                margin-left: rem(30px);

                @media #{$screen-big} {
                    margin-left: rem(34px);
                }

                @media (#{$screen-medium}) {
                    margin-left: rem(27px);
                }

                @media #{$screen-small} {
                    margin: 0;
                }
            }

            &:nth-child(2) {
                align-self: flex-end;

                margin-right: rem(49px);

                @media #{$screen-big} {
                    margin-right: 0;
                }

                @media (#{$screen-medium}) {
                    margin-right: rem(-37px);
                }

                @media #{$screen-small} {
                    align-self: flex-start;

                    margin: 0;
                }
            }

            &:nth-child(3) {
                @media (#{$screen-medium}) {
                    margin-bottom: rem(17px);
                }

                @media #{$screen-small} {
                    margin: 0;
                }
            }
        }
    }
}
</style>